<template>
	<div class="store-finder-search-wrapper">
		<div class="sw-top">
			<label for="storeSearch">Find a Store</label>
			<div class="input-with-btn" @keydown.enter="findStore">
				<input
					id="storeSearch"
					style="font-family: Roboto;font-weight: 400;"
					v-model="query"
					type="text"
					placeholder="ZIP Code, City, State, or Store #"
				/>
				<ui-button
					@click="findStore"
					color="soft-blue"
					size="md"
					style="max-width: 100px;"
				>
					<i v-if="searching" class="fa fa-spinner fa-spin"></i>
					{{ searching ? '' : 'Search' }}
				</ui-button>
			</div>
		</div>
		<div v-if="error" class="error-container">
			<span class="icon icon-alert-outline"></span> {{ error }}
		</div>
		<div class="btn-box">
			<ui-button
				color="soft-blue-outline"
				size="md"
				style="max-width: 100%;"
				@click="findNearMe"
			>
				Use My Location
			</ui-button>
		</div>
	</div>
</template>

<script>
import { get, sync } from 'vuex-pathify';
export default {
	name: 'StoreSearch',
	computed: {
		error: get('error'),
		searching: get('searching'),
		query: sync('query'),
	},
	data() {
		return {
			stores: null,
		};
	},
	methods: {
		findNearMe() {
			if (this.searching) return;
			this.query = '';
			this.$store.dispatch('findStore');
		},
		findStore() {
			if (this.searching) return;
			this.$store.dispatch('findStore');
		},
	}
};
</script>

<style lang='less' scoped>
@import '../../../less/_mixins.less';
.store-finder-search-wrapper {
	background-color: #F7F8FB;
	.sw-top {
		padding: 16px 15px 11px 15px;
		.ms-styles({
			padding: 10px 15px;
		});
	}
	span, label {
		color: #014A77;
		font-size: 16px;
		font-weight: bold;
	}
}
.input-with-btn {
	display: flex;
	margin-top: 10px;
	position: relative;
	input {
		color: #6671A3;
		padding: 10px 12px;
		border: 1px solid #CBD0E5;
		border-radius: 6px 0 0 6px;
		flex: 1;
		font-weight: bold;
		font-size: 14px;
		&::placeholder {
			color: #6671A3;
		}
		.tablet-styles({
			margin-right: 90px;
			padding: 10px 20px 10px 12px;
		});
		.ms-styles({
			font-size: 12px;
			font-weight: 400;
			padding: 5px 4px 5px 8px;
		});
	}
	.ui-btn {
		border-radius: 0 6px 6px 0;
		padding: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		.tablet-styles({
			position: absolute;
			right: 0;
			top: 0;
			bottom: 0;
		});
		.mobile-styles({
			font-size: 14px;
		});
	}
}
.btn-box {
	border-top: 2px solid #CBD0E5;
	background-color: #E5E7F1;
	padding: 10px 15px;
}
.error-container {
	color: darkred;
	padding: 0 15px 10px 15px;
	font-size: 14px;
	line-height: 1.25em;
	.icon {
		color: darkred !important;
	}
}
</style>